module.exports = __webpack_public_path__ + "img/room.100ae770.svg";